document.addEventListener('DOMContentLoaded', function () {
    // QUICK SEARCH FUNCTIONALITY
    const baseUrl = window.location.origin;
    const quickSearches = document.querySelectorAll('.quick-search');

    if (quickSearches !== null) {
        quickSearches.forEach(initQuickSearch);
    }

    function initQuickSearch(quickSearch) {
        const quickSearchId = 'quick-search-' + Math.floor(Math.random() * 100000);
        const quickSearchLabel = quickSearch.querySelector('label');
        const searchInput = quickSearch.querySelector('input');
        const searchResultsContainer = quickSearch.querySelector('.quick-search-results-container__inner');

        quickSearchLabel.setAttribute('for', quickSearchId);
        searchInput.setAttribute('id', quickSearchId);

        if (window.innerWidth < 768) {
            searchInput.setAttribute('placeholder', 'Search');
        }

        if (searchInput !== null) {
            searchInput.addEventListener('input', debounce(function () {
                search(searchInput, searchResultsContainer);
            }, 300));
        }
    }

    function search(searchInput, searchResultsContainer) {
        let searchTerm = searchInput.value;

        // toggle between display block and none
        if (searchTerm.length > 0) {
            searchResultsContainer.parentNode.style.display = 'block';
        } else {
            searchResultsContainer.parentNode.style.display = 'none';
        }

        // Search for posts and users
        fetch(`/wp-json/custom/v1/quicksearch/?search=${searchTerm}`)
            .then(response => response.json())
            .then(resultData => {
                const groupedResults = groupResultsByType(resultData);

                // Clear previous search results
                searchResultsContainer.innerHTML = '';

                if (Object.keys(groupedResults).length > 0) {
                    displayResultsByType(groupedResults, searchResultsContainer);
                    displayViewMoreLink(searchResultsContainer, searchTerm);
                } else {
                    displayNoResultsMessage(searchResultsContainer);
                }
            })
            .catch(error => console.error(error));
    }

    function groupResultsByType(resultData) {
        const groupedResults = {};

        resultData.forEach(post => {
            const postType = post.type;
            if (!groupedResults[postType]) {
                groupedResults[postType] = [];
            }
            groupedResults[postType].push(post);
        });

        return groupedResults;
    }

    function displayResultsByType(groupedResults, searchResultsContainer) {
        Object.keys(groupedResults).forEach(resultType => {
            const existingHeader = searchResultsContainer.querySelector(`.quick-search-results-type--${resultType} h3`);

            // Check if the header already exists in HTML
            if (!existingHeader) {
                const resultTypeContainer = document.createElement('div');
                resultTypeContainer.classList.add('quick-search-results-type', 'quick-search-results-type--' + resultType);

                const resultTypeHeader = document.createElement('h3');
                resultTypeHeader.textContent = getResultTypeHeader(resultType);
                resultTypeContainer.appendChild(resultTypeHeader);

                const resultTypeList = document.createElement('ul');
                resultTypeList.classList.add('quick-search-results-list');

                groupedResults[resultType].forEach(result => {
                    const listItem = createResultListItem(result);
                    resultTypeList.appendChild(listItem);
                });

                resultTypeContainer.appendChild(resultTypeList);
                searchResultsContainer.appendChild(resultTypeContainer);
            } else {
                // If the header already exists, just update the content
                const resultTypeList = document.createElement('ul');
                resultTypeList.classList.add('quick-search-results-list');

                groupedResults[resultType].forEach(result => {
                    const listItem = createResultListItem(result);
                    resultTypeList.appendChild(listItem);
                });

                existingHeader.parentNode.appendChild(resultTypeList);
            }
        });
    }

    function getResultTypeHeader(resultType) {
        switch (resultType) {
            case 'event':
                return 'Events';
            case 'post':
                return 'Blog';
            case 'story':
                return 'Stories';
            case 'wpbdp_listing':
                return 'Directory Listings';
            case 'qa-guide':
                return 'Q&A';
            default:
                return resultType.charAt(0).toUpperCase() + resultType.slice(1);
        }
    }

    function decodeHtmlEntities(html) {
        var txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value;
    }

    function createResultListItem(result) {
        const listItem = document.createElement('li');
        const link = document.createElement('a');
        link.href = result.url;

        // set title and make html characters render
        let title = decodeHtmlEntities(result.title);

        if (result.type === 'event' && result._event_start_date) {
            const eventStartDate = new Date(result._event_start_date);
            const options = { year: 'numeric', month: 'short', day: 'numeric' };
            const formattedStartDate = eventStartDate.toLocaleDateString(undefined, options);
            const timeDiv = document.createElement('div');
            timeDiv.classList.add('result-time');
            timeDiv.textContent = formattedStartDate;
            link.appendChild(timeDiv);
        }

        const titleDiv = document.createElement('div');
        titleDiv.classList.add('result-title');
        titleDiv.textContent = title;
        link.appendChild(titleDiv);

        listItem.appendChild(link);
        return listItem;
    }

    function displayViewMoreLink(searchResultsContainer, searchTerm) {
        if (searchResultsContainer.parentNode.querySelector('.quick-search-results-more') === null) {
            const searchResultsMore = document.createElement('a');
            searchResultsMore.classList.add('quick-search-results-more');
            searchResultsMore.textContent = 'View All Results';
            searchResultsMore.href = `${baseUrl}/?s=${searchTerm}`;
            searchResultsContainer.parentNode.appendChild(searchResultsMore);
        }
    }

    function displayNoResultsMessage(searchResultsContainer) {
        const noResultsMessage = document.createElement('p');
        noResultsMessage.classList.add('no-results-message');
        noResultsMessage.textContent = 'No results found.';
        searchResultsContainer.appendChild(noResultsMessage);
    }

    function debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }
    // END QUICK SEARCH FUNCTIONALITY
}, false);
